import { Directive, Input, inject } from '@angular/core'
import {
  ElderEnumTranslationService,
  ElderSelectComponent,
  TranslatedEnumValue,
} from '@elderbyte/ngx-starter'
import { PackageState } from '../package'

@Directive({
  selector: '[appPackageStateSelect]',
})
export class PackageStateSelectDirective {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  private select = inject(ElderSelectComponent)

  @Input()
  public disabled: PackageState[] = [PackageState.PREDICTED]

  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor() {
    const enumTranslationService = inject(ElderEnumTranslationService)
    this.select.placeholder = 'context.type'
    this.select.displayProperty = 'displayValue'
    this.select.dataSource = enumTranslationService.enumDataSource(
      PackageState,
      'packages.state',
      false
    )
    this.select.isOptionDisabledFn = (option: TranslatedEnumValue) =>
      this.disabled.some((state) => state === option.value)
  }
}
